import { createApi } from '@reduxjs/toolkit/query/react';
import type { CustomerUploadLinkDto, CreateUploadLinkRequest } from '@/types';
import { baseQueryWithRetry } from './baseQuery';
import { TAG_CUSTOMER_UPLOAD_LINK } from '@/store/tagTypes';

export const customerUploadLinksApi = createApi({
  reducerPath: 'customerUploadLinksApi',
  baseQuery: baseQueryWithRetry,
  tagTypes: [TAG_CUSTOMER_UPLOAD_LINK],
  endpoints: (builder) => ({
    listCustomerUploadLinks: builder.query<CustomerUploadLinkDto[], string>({
      query: (customerId) => ({
        url: '/customer-upload-links',
        params: { customerId },
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: TAG_CUSTOMER_UPLOAD_LINK, id })),
              { type: TAG_CUSTOMER_UPLOAD_LINK, id: 'LIST' },
            ]
          : [{ type: TAG_CUSTOMER_UPLOAD_LINK, id: 'LIST' }],
    }),

    createCustomerUploadLink: builder.mutation<CustomerUploadLinkDto, CreateUploadLinkRequest>({
      query: (body) => ({
        url: '/customer-upload-links',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: TAG_CUSTOMER_UPLOAD_LINK, id: 'LIST' }],
    }),

    revokeCustomerUploadLink: builder.mutation<void, string>({
      query: (id) => ({
        url: `/customer-upload-links/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: TAG_CUSTOMER_UPLOAD_LINK, id },
        { type: TAG_CUSTOMER_UPLOAD_LINK, id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useListCustomerUploadLinksQuery,
  useCreateCustomerUploadLinkMutation,
  useRevokeCustomerUploadLinkMutation,
} = customerUploadLinksApi;
